export default __webpack_public_path__ + "static/media/bg-1.29793f74.jpg";